import React from 'react';
import { Box, Container, Grid, Link, Divider } from '@mui/material';
import Typo from './Typo';
import { useTranslation } from 'react-i18next';
const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#212529',
        py: 8,
        color: '#fff',
        mt: 'auto',
        width: '100%',
        position: 'relative',
        px: 5,
        zIndex: 10,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5}>
          <Grid item xs={12} md={3}>
            <Box sx={{ mb: 3 }}>
              <Box
                component="img"
                src="/assets/chekup/chekup-logo.svg"
                alt="CHEK UP"
                sx={{ height: 40, mb: 3, filter: 'brightness(0) invert(1)' }}
              />
              <Typo
                variant="body2"
                text={t('footerDescription')}
                sx={{
                  mb: 2,
                  color: '#ffffff',
                  fontSize: '14px',
                  lineHeight: 1.5,
                  fontFamily: 'Montserrat',
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typo
              variant="subtitle1"
              text={t('footerProduct')}
              sx={{
                mb: 3,
                color: '#ffffff',
                fontWeight: 700,
                fontSize: '16px',
                fontFamily: 'Montserrat',
              }}
            />
            <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
              {[
                t('footerProduct1'),
                t('footerProduct2'),
                t('footerProduct3'),
              ].map((item, index) => (
                <Box component="li" key={item} sx={{ mb: 2 }}>
                  <Link
                    href={index === 0 ? 'https://chekup.ca/platform' : index === 1 ? 'https://chekup.ca/approch' : 'https://chekup.ca/use-cases'}
                    sx={{
                      color: '#ffffff',
                      opacity: 0.7,
                      textDecoration: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        color: '#ffffff',
                        opacity: 1,
                        textDecoration: 'none',
                      },
                    }}
                  >
                    {item}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typo
              variant="subtitle1"
              text={t('footerEntreprise')}
              sx={{
                mb: 3,
                color: '#ffffff',
                fontWeight: 700,
                fontSize: '16px',
                fontFamily: 'Montserrat',
              }}
            />
            <Box component="ul" sx={{ pl: 0, listStyle: 'none' }}>
              {[
                t('footerDemo'),
                t('footerUseNode'),
              ].map((item, index) => (
                <Box component="li" key={item} sx={{ mb: 2 }}>
                  <Link
                    href={index === 0 ? 'https://chekup.ca/meet-chekup' : 'https://usenode.com'}
                    sx={{
                      color: '#ffffff',
                      opacity: 0.7,
                      textDecoration: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        color: '#ffffff',
                        opacity: 1,
                        textDecoration: 'none',
                      },
                    }}
                  >
                    {item}
                  </Link>
                </Box>
              )
              )}
            </Box>
          </Grid>

          <Grid item xs={6} md={3}>
            <Typo
              variant="subtitle1"
              text={t('footerLegal')}
              sx={{
                mb: 3,
                color: '#ffffff',
                fontWeight: 700,
                fontSize: '16px',
                fontFamily: 'Montserrat',
              }}
            />
            <Box component="ul" sx={{ pl: 0, listStyle: 'none', mb: 4 }}>
              {[
                t('footerPrivacy'),
              ].map((item) => (
                <Box component="li" key={item} sx={{ mb: 2 }}>
                  <Link
                    href={'https://chekup.ca/privacy'}
                    sx={{
                      color: '#ffffff',
                      opacity: 0.7,
                      textDecoration: 'none',
                      fontFamily: 'Montserrat',
                      fontSize: '14px',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        color: '#ffffff',
                        opacity: 1,
                        textDecoration: 'none',
                      },
                    }}
                  >
                    {item}
                  </Link>
                </Box>
              ))}
            </Box>


          </Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)', my: 4 }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'flex-start' },
          }}
        >
          <Typo
            variant="body2"
            text={`© ${new Date().getFullYear()} Intelligence Node Canada. Tous droits réservés.`}
            sx={{
              mb: { xs: 2, sm: 0 },
              color: '#ffffff',
              opacity: 0.7,
              fontSize: '14px',
              fontFamily: 'Montserrat',
            }}
          />

        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
